import { render, staticRenderFns } from "./Feeorder.vue?vue&type=template&id=3829e2c9&"
import script from "./Feeorder.vue?vue&type=script&lang=js&"
export * from "./Feeorder.vue?vue&type=script&lang=js&"
import style0 from "./Feeorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports